import * as Mui from "@mui/material";
import { AxiosError } from "axios";
import dayjs from "dayjs";
import { useContext } from "react";
import { ContextOperation } from "../../../context/OperationContext";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import useSnackbar from "../../../hooks/useSnackbar";
import { AutoCompleteOption } from "../../common/AutoComplete";
import VehicleAvailabilityService, { EnumReasonCodeState, IUnavailabilityReasonRequest } from "../service/VehicleAvailabilityService";

interface Props {
  tenant:string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  listStatus: AutoCompleteOption[];
  vehicleId: number;
  listBlocks: IUnavailabilityReasonRequest[];
}

const ConfirmBlock = (props: Props) => {
  const {setLoading} = useContext(ContextOperation);
  const t = useOperationTranslation();

  const snackbar = useSnackbar();

  const onConfirm = () => {
    setLoading(true);
    VehicleAvailabilityService.update.unavailabilityReasons(props.tenant,props.vehicleId, props.listBlocks).then(
      response => {
        props.onClose();
        setLoading(false);
        snackbar.show("success", t("vehicleAvailability.status.confirmBlocks.successfull"));
        props.onConfirm();
      },
      (reject: AxiosError) => {
        const data: any = reject.response?.data;

        if (data?.subCode && data.subCode === 1) {
          const dateMessage = data.msg ? dayjs(data.msg).format(dateFormat) : "";
          snackbar.show("error", t("vehicleAvailability.status.confirmBlocks.errorDate").replace("#dataMessage", dateMessage));
        } else {
          snackbar.show("error", t("vehicleAvailability.status.confirmBlocks.error"));
        }
        props.onClose();
        setLoading(false);
      }
    )
  }

  const dateFormat = "DD/MM/YYYY HH:mm";
  return (
    <Mui.Dialog open={props.open} onClose={props.onClose}>
      <Mui.Grid container wrap="nowrap">
        <Mui.DialogContent>
          <>
            <Mui.Typography whiteSpace="pre-line" variant="body1">
                {props.listBlocks.length == 0 && t("vehicleAvailability.status.confirmBlocks.titleEmptyList")}
                {props.listBlocks.length > 0 && t("vehicleAvailability.status.confirmBlocks.title")}
            </Mui.Typography>
    
            {props.listBlocks.map((element, index) => {
              if (element.reasonCodeState === EnumReasonCodeState.CLOSED) {
                  return null;
              }

              const statusReason = props.listStatus.find(status => status.value === element.statusReasonCode)?.label;
              const startDate = dayjs(element.expectedStartUnavailabilityDatetime).format(dateFormat);
              const endDate = element.expectedEndUnavailabilityDatetime ? ` ${t("vehicleAvailability.status.confirmBlocks.to")} ${dayjs(element.expectedEndUnavailabilityDatetime).format(dateFormat)}`: "";
              return(
                <Mui.List style={{display:'list-item', listStyleType: "none"}}>
                  <Mui.Typography variant="h6">
                    {`"${statusReason} - ${t("vehicleAvailability.status.confirmBlocks.from")} ${startDate}${endDate}"`}
                    {index === (props.listBlocks.length -1) &&  "?"}
                  </Mui.Typography>
                </Mui.List>
              )
            })}
            
          </>
        </Mui.DialogContent>
      </Mui.Grid>  

      <Mui.DialogActions>
        <Mui.Grid container spacing={{ md:2, xs:2 }}>
          <Mui.Grid item md={6} xs={12}>
            <Mui.Button onClick={onConfirm} fullWidth>
              {t("vehicleAvailability.status.confirmBlocks.confirmButton")}
            </Mui.Button>
          </Mui.Grid>
          <Mui.Grid item md={6} xs={12}>
            <Mui.Button variant="outlined" onClick={props.onClose} fullWidth>
              {t("vehicleAvailability.status.confirmBlocks.cancelButton")}
            </Mui.Button>
          </Mui.Grid> 
        </Mui.Grid>
      </Mui.DialogActions>
    </Mui.Dialog>
  )
}
export default ConfirmBlock;